import type { IconProps } from '@phosphor-icons/react'

// App-wide Phosphor defaults. The provider value replaces Phosphor's default
// context wholesale, so size/color/mirrored must be restated or unsized icons
// lose their 1em width. Every key here is spread onto each <svg>: aria-hidden
// keeps decorative icons out of the accessibility tree, as lucide did (pass
// aria-hidden={false} with an aria-label for a meaningful icon). Server-rendered
// icons (dist/ssr) don't read this context.
export const ICON_DEFAULTS: IconProps = {
  size: '1em',
  color: 'currentColor',
  mirrored: false,
  weight: 'duotone',
  'aria-hidden': true,
}
